/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Outcomeformsummaryagreed3Inputs */

const en_outcomeformsummaryagreed3 = /** @type {(inputs: Outcomeformsummaryagreed3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Contractor agreed to fix it on ${i?.when}`)
};

const pt_outcomeformsummaryagreed3 = /** @type {(inputs: Outcomeformsummaryagreed3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Empreiteiro aceitou resolver em ${i?.when}`)
};

/**
* | output |
* | --- |
* | "Contractor agreed to fix it on {when}" |
*
* @param {Outcomeformsummaryagreed3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeformsummaryagreed3 = /** @type {((inputs: Outcomeformsummaryagreed3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeformsummaryagreed3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeformsummaryagreed3(inputs)
	return pt_outcomeformsummaryagreed3(inputs)
});
export { outcomeformsummaryagreed3 as "outcomeFormSummaryAgreed" }